import React, { useState, useEffect } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import loaderGif from "../../../assets/loader.gif";
import api from '../../../config/axiosConfig';
import banner from "../../../assets/sectbanner.webp";
import Header from "../Header";
import Footer from "../Footer/Footer";
import '../contact/Contact.css';
import axios from "axios";
import { Modal } from "react-bootstrap";
// import { getTable } from "../../../config/seatable";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        id: null,  // Track if it's a new entry or an edit
        name: '',
        organization: '',
        mobile: '',
        email: '',
        noOfGuests: '',
        noOfCouples: '',
        notes: '',
        programs: [],
        residenceType: [],
        duration: [],
        source: [],
        subscription: [],
        checkinDate: '',
        checkoutDate: '',
        createddate: '',
        guestCity: '',
        travelMedium: ''
    });

    const [isEditMode, setIsEditMode] = useState(false); // To track if we are in edit mode
    const [loader, setLoader] = useState(false);
    const [programs, setprograms] = useState();
    const [residentsTypes, setResidentsType] = useState();
    const [customProgram, setCustomProgram] = useState('');
    const [magazineValue, setMagazineValue] = useState('');
    const [influencerReelValue, setInfluencerReelValue] = useState('');
    const [travelAgencyValue, setTravelAgencyValue] = useState('');
    const [strategicPartnerValue, setStrategicPartnerValue] = useState('');
    const [referralName, setReferralName] = useState('');
    const [otherValue, setOtherValue] = useState('');
    const [travelMediumOtherValue, setTravelMediumOtherValue] = useState('');
    const [couples, setCouples] = useState(0);
    const [guests, setGuests] = useState(0);


    const getPrograms = async () => {
        try {

            // const contactdata = await getTable("Guest Booking");
            // console.log("contact data", contactdata);
            const programs = await api.get('/programs');
            setprograms(programs.data);


        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getResidentsType = async () => {
        try {
            const residentsTypes = await api.get('/residentialTypes');
            setResidentsType(residentsTypes.data);


        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        getPrograms();
        getResidentsType();
    }, []);

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData((prevState) => ({
            ...prevState,
            [name]: type === "checkbox" ? checked : value,
        }));

        if (name === "noOfCouples") {
            setCouples(Number(value)); // Convert to number
        }

        if (name === "noOfGuests") {
            setGuests(Number(value));
        }
    };

    const totalGuests = 2 * couples + guests; // Total guest calculation

    // Handle form submission for adding/updating media
    const handleAddData = async (e) => {
        e.preventDefault();

        // Custom validation
        if (formData.programs.length === 0) {
            alert("Please select at least one program.");
            return;
        }

        if (formData.residenceType.length === 0) {
            alert("Please select at least one residence type.");
            return;
        }

        if (formData.duration.length === 0) {
            alert("Please select at least one program duration.");
            return;
        }

        if (formData.source.length === 0) {
            alert("Please select at least one option for 'How did you hear about us?'");
            return;
        }

        setLoader(true);

        const updatedPrograms = formData.programs.map((program) =>
            program === "Other/Custom" && customProgram
                ? `${program} : ${customProgram}`
                : program
        ).join(', ');

        const updatedTravelMedium = formData.travelMedium.map((medium) =>
            medium === "Other" && travelMediumOtherValue
                ? `${medium} : ${travelMediumOtherValue}`
                : medium
        ).join(', ');

        const updatedSource = formData.source
            .map((item) =>
                item === "Magazine/Article" && magazineValue
                    ? `${item} : ${magazineValue}`
                    : item
            ).map((item) =>
                item === "Influencer Reel" && influencerReelValue
                    ? `${item} : ${influencerReelValue}`
                    : item
            ).map((item) =>
                item === "Travel Agent/Online Agency" && travelAgencyValue
                    ? `${item} : ${travelAgencyValue}`
                    : item
            ).map((item) =>
                item === "Strategic Partner" && strategicPartnerValue
                    ? `${item} : ${strategicPartnerValue}`
                    : item
            ).map((item) =>
                item === "Referral" && referralName
                    ? `${item}: ${referralName}`
                    : item
            ).map((item) =>
                item === "Other" && otherValue
                    ? `${item}: ${otherValue}`
                    : item
            ).join(', ');


        //DateRange input cutomization    
        let updatedDateRange = null;
        if (formData.checkinDate && formData.checkoutDate) {
            updatedDateRange = `${formData.checkinDate} to ${formData.checkoutDate}`;
        } else if (formData.checkinDate) {
            updatedDateRange = `From ${formData.checkinDate}`;
        } else if (formData.checkoutDate) {
            updatedDateRange = `Till ${formData.checkoutDate}`;
        }
          const publicIP = await axios.get('https://api.ipify.org?format=json');
          const ipInforesponse = await api.get(`/commonroutes/ipInfo/${publicIP.data.ip}`)
        //   const userAGInfo = await api.get(`/commonroutes/ipInfo/${publicIP.data.ip}`)
          const selectedIpInfo = ipInforesponse.data.ipInfo || {};
          const userAginfo = ipInforesponse.data.userAGInfo || {};
          const ip = selectedIpInfo.ip;
          const city = selectedIpInfo.city;
          const region = selectedIpInfo.region;
          const country = selectedIpInfo.country;
          const timezone = selectedIpInfo.timezone;
          const location = selectedIpInfo.loc
          const browser = userAginfo.browser.name;
          const os = userAginfo.os.name;

        // Prepare data for media entry
        const contactFormData = {
            name: formData.name,
            organization: formData.organization,
            mobile: formData.mobile,
            email: formData.email,
            noOfGuests: formData.noOfGuests || null,
            noOfCouples: formData.noOfCouples || null,
            notes: formData.notes,
            programs: updatedPrograms,
            residenceType: formData.residenceType.join(', ') || null,
            duration: formData.duration.join(', '),
            source: updatedSource,
            subscription: formData.subscription.join(', '),
            dateRange: updatedDateRange,
            createdat: new Date(),
            guestCity: formData.guestCity,
            travelMedium: updatedTravelMedium,
            ip: ip,
            city: city,
            region: region,
            country: country,
            timezone: timezone,
            location: location,
            browser: browser,
            os: os

        };

        // Determine whether to update or create a new entry
        const url = '/contactform';
        const request = api.post(url, contactFormData);
          
        try {
            
            await request;
            // Clear form fields and reset edit mode
            setFormData({ id: null, name: '', organization: '', mobile: '', email: '', noOfGuests: '', noOfCouples:'', notes: '', programs: [], residenceType: [], duration: [], source: [], subscription: [], checkinDate: '', checkoutDate: '',  guestCity: '', travelMedium: ''});
            setCustomProgram('');
            setMagazineValue('');
            setInfluencerReelValue('');
            setTravelAgencyValue('');
            setStrategicPartnerValue('');
            setReferralName('');
            setOtherValue('');
            setTravelMediumOtherValue('');
            setIsEditMode(false);
            setLoader(false);
            

        } catch (error) {
            console.error("Error adding/updating enquiries:", error);
            setLoader(false);
        }
    };



    // Reset form for new entry
    const handleNewEntry = () => {
        setFormData({ id: null, name: '', organization: '', mobile: '', email: '', noOfGuests: '', noOfCouples:'',  notes: '', programs: '', residenceType: '', duration: '', source: '', subscription: '',  checkinDate: '', checkoutDate: '',  guestCity: '', travelMedium: ''});
        // setFiles([]);
        setIsEditMode(false);  // Switch to add mode
    };

    const handleProgramChange = (e, programId, programName) => {
        const { checked, value } = e.target;
    
        setFormData((prevState) => {
            let updatedPrograms = [...prevState.programs];
    
            if (value === "Other/Custom") {
                if (checked) {
                    updatedPrograms.push(value);
                } else {
                    updatedPrograms = updatedPrograms.filter((p) => p !== "Other/Custom");
                }
            } else {
                if (checked) {
                    updatedPrograms.push(programName);
                } else {
                    updatedPrograms = updatedPrograms.filter((p) => p !== programName);
                }
            }
    
            return { ...prevState, programs: updatedPrograms };
        });
    
        // Reset custom input field when unchecked
        if (!checked && value === "Other/Custom") {
            setCustomProgram("");
        }
    };

    

    const handleResidenceTypeChange = (e, residenceId, residenceName) => {
        const { checked } = e.target;
        setFormData((prevState) => {
            const selectedResidenceTypes = [...prevState.residenceType];
            if (checked) {
                selectedResidenceTypes.push(residenceName);
            } else {
                const index = selectedResidenceTypes.indexOf(residenceName);
                if (index > -1) {
                    selectedResidenceTypes.splice(index, 1);
                }
            }
            return { ...prevState, residenceType: selectedResidenceTypes };
        });
    };

    const handleProgramDurationChange = (e, duration) => {
        const { checked } = e.target;
        setFormData((prevState) => {
            const selectedDurations = [...prevState.duration];
            const valueToPush = duration === "2-5 Days" || duration === "Other" ? duration : parseInt(duration, 10);
            if (checked) {
                selectedDurations.push(valueToPush);
            } else {
                const index = selectedDurations.indexOf(valueToPush);
                if (index > -1) {
                    selectedDurations.splice(index, 1); // Remove duration from the list
                }
            }
            return { ...prevState, duration: selectedDurations };
        });
    };
    

    const handleSourceChange = (e) => {
        const { value, checked } = e.target;

        setFormData((prevState) => {
            const updatedSource = [...prevState.source];
            if (checked) {
                updatedSource.push(value);
            } else {
                const index = updatedSource.indexOf(value);
                if (index > -1) {
                    updatedSource.splice(index, 1);
                }
            }
            return { ...prevState, source: updatedSource };
        });

        if (!checked && value === 'Magazine/Article') {
            setMagazineValue('');
        } else if (!checked && value === 'Influencer Reel') {
            setInfluencerReelValue('');
        } else if (!checked && value === 'Travel Agent/Online Agency') {
            setTravelAgencyValue('');
        } else if (!checked && value === 'Strategic Partner') {
            setStrategicPartnerValue('');
        } else if (!checked && value === 'Referral') {
            setReferralName('');
        } else if (!checked && value === 'Other') {
            setOtherValue('');
        }
    };

    const handleSubscriptionChange = (e) => {
        const { value, checked } = e.target;

        setFormData((prevState) => {
            const updatedSubscription = [...prevState.subscription];
            if (checked) {
                if (!updatedSubscription.includes(value)) {
                    updatedSubscription.push(value);
                }
            } else {
                const index = updatedSubscription.indexOf(value);
                if (index > -1) {
                    updatedSubscription.splice(index, 1);
                }
            }
            return { ...prevState, subscription: updatedSubscription };
        });
    };

    const handleTravelMediumChange = (e) => {
        const { value, checked } = e.target;

        setFormData((prevState) => {
            const updatedTravelMedium = [...prevState.travelMedium];
            if (checked) {
                updatedTravelMedium.push(value);
            } else {
                const index = updatedTravelMedium.indexOf(value);
                if (index > -1) {
                    updatedTravelMedium.splice(index, 1);
                }
            }
            return { ...prevState, travelMedium: updatedTravelMedium };
        });

        if (!checked && value === 'Other') {
            setTravelMediumOtherValue('');
        }
    };


    const [show, setShow] = useState(false);

    const handleclose = () => setShow(false);

    const handleshow = () => setShow(true);

    return (
        <>
            <Header />
          {/* <div className="inner-banner pb-5" id="hero">
      <div className="bannar">
        <img src={banner} alt="banner" loading="lazy" />
      </div>
      <div className="bannar-text-div">
        <h2 className="bannar-text">Contact</h2>
      </div>
    </div> */}
            <Container fluid className="contactus">

                 <div className="w-80 mx-auto text-white d-flex align-items-center flex-column justify-content-center text-center px-5">
                    <h4 className="text-start">Thank you for connecting with us. Please complete the form below and we will revert back within 2 hrs.</h4>
                    <p className="text-start">We offer several standard programs and packages.</p>
                    <p className="text-start">We can also customize several programs depending on your requirments.</p>
                        <button className="mb-5 px-4 py-2" style={{backgroundColor:"#E6BE80", color:"#fff"}} onClick={handleshow}>
                            Contact Us
                        </button>

                              {/* MODAL */}
                                            <Modal
                                                show={show}
                                                onHide={handleclose}
                                                centered
                                                size="xl"
                                            >

                                                <Modal.Header closeButton>
                                                <Modal.Title>
                                                    Contact Form
                                                </Modal.Title>
                                                </Modal.Header>

                                                <Modal.Body style={{ padding: 0 }}>

                                                <iframe
                                                    src="https://cms.allteam.com/dtable/forms/8a9ea168-c070-4534-b2a2-eb9bb40bcf18/"
                                                    width="100%"
                                                    height="600"
                                                    frameBorder="0"
                                                    marginHeight="0"
                                                    marginWidth="0"
                                                    title="Google Form"
                                                >
                                                    Loading…
                                                </iframe>

                                                </Modal.Body>

                                            </Modal>

                </div>
                
            {/* <div className="text-center mt-5"><h2 className="bannar-text pb-5">Contact Us</h2></div>
                <div className="w-80 mx-auto text-white d-flex align-items-center flex-column justify-content-center text-center px-5">
                    <h4 className="text-start">Thank you for connecting with us. Please complete the form below and we will revert back within 2 hrs.</h4>
                    <p className="text-start">We offer several standard programs and packages.</p>
                    <p className="text-start">We can also customize several programs depending on your requirments.</p>
                </div>

              <Container fluid className="px-md-5 px-3">
              <Row className=" p-4">
                    {loader && (
                        <div className="loader-overlay">
                                <img src={loaderGif} alt="Loading..." className="loader" loading="lazy" />
                        </div>
                    )}
                    <Col md={4} className="pt-5">
                    <div className="px-md-5 px-3  py-lg-0 py-2 gateway-box row g-0 " id="gateway-box1">
          <div  >
              <div className="elementor-icon-box-icon">
                
          </div>

          <div >
              <div className="elementor-icon-box-icon">
                  <span className="elementor-icon elementor-animation-">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
                     <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
                  </svg>
                </span>
                  </div>
                  <div className="elementor-icon-box-content text-white">
                  <h5 className="elementor-icon-box-title">
                  <span >
                 Connect us</span>
                  </h5>
                  <p className="elementor-icon-box-description pb-0 mb-0">
                      Call: +91 820 805 3493  </p>
                      <p  className="elementor-icon-box-description pb-0">
                      Email: contact@belantarabeachestate.com
                      </p>
                  </div>
          </div>

          <div>
              <div className="elementor-icon-box-icon" >
                  <span className="elementor-icon elementor-animation-">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send-arrow-up-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M15.854.146a.5.5 0 0 1 .11.54L13.026 8.03A4.5 4.5 0 0 0 8 12.5c0 .5 0 1.5-.773.36l-1.59-2.498L.644 7.184l-.002-.001-.41-.261a.5.5 0 0 1 .083-.886l.452-.18.001-.001L15.314.035a.5.5 0 0 1 .54.111M6.637 10.07l7.494-7.494.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154z"/>
  <path fill-rule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.354a.5.5 0 0 0-.722.016l-1.149 1.25a.5.5 0 1 0 .737.676l.28-.305V14a.5.5 0 0 0 1 0v-1.793l.396.397a.5.5 0 0 0 .708-.708z"/>
</svg>
                 </span>
                  </div>
                  <div className="elementor-icon-box-content text-white">
                  <h5 className="elementor-icon-box-title">
                  <span>
                  Address </span>
                  </h5>
                  <p className="elementor-icon-box-description" >
                    Pagerewadi Khavne, Vengurla Sindhudurg,
                    Maharashtra,416522</p>
                  </div>
          </div>
                </div>

                        </Col>
                        <Col md={8} className="contactform pt-5">
                            <Form onSubmit={handleAddData}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="me-3">Your Name*</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="Enter your name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="me-3">Organization Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="organization"
                                                placeholder="Enter Organization Name"
                                                value={formData.organization}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row><br />
                                <Row>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="me-3">Your City</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="guestCity"
                                                placeholder="Enter Your City Name"
                                                value={formData.guestCity}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Mobile Number*</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="mobile"
                                                placeholder="Enter Mobile Number"
                                                value={formData.mobile}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                   
                                </Row><br />
                                <Row className="mb-4">                          
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Email-ID*</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="Email"
                                                    name="email"
                                                    placeholder="Enter Email address"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Notes/Special Requirements</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    as="textarea" // Use 'as' to specify the HTML element
                                                    rows={1}      // Optional: Number of rows for the textarea
                                                    name="notes"
                                                    placeholder="Enter Notes/Special Requirements"
                                                    value={formData.notes}
                                                    onChange={handleChange}
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row><br />
                                <Row className="mb-4">
                                    <Col md={6}>
                                    <Form.Group>
                                    <Form.Label>Number of guests older than 6</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            name="noOfGuests"
                                            placeholder="Enter Number of Guests"
                                            value={formData.noOfGuests}
                                            onChange={handleChange}
                                            min="1" // Ensures users can't enter numbers less than 1
                                            required
                                        />
                                    </InputGroup>
                                   { formData.noOfGuests !== "" && Number(formData.noOfGuests) === 0 && (
                                        <Form.Text className="text-danger">
                                            Number of guests must be greater than 0.
                                        </Form.Text>
                                    )}
                                </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Number of Couples</Form.Label>
                                            <InputGroup >
                                                <Form.Control
                                                    type="number"
                                                    name="noOfCouples"
                                                    placeholder="Enter Number of Couples"
                                                    value={formData.noOfCouples}
                                                    onChange={handleChange}
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>  
                                    <Row>
                                    <Col md={12}>
                                    <div className="mt-4 font-semibold text-lg text-white">
                                        Total Guests: {totalGuests}
                                    </div>
                                    </Col>
                                </Row>                         
                                </Row>
                                
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <Form.Group className="contact-chckbox">
                                            <Form.Label>Program(s) Interested in:*</Form.Label>
                                            {programs && programs.map((program) => (
                                                <Form.Check
                                                    key={program.id}
                                                    type="checkbox"
                                                    label={program.name}
                                                    name="programs"
                                                    value={program.id}
                                                    checked={formData.programs.includes(program.name)} // Check if selected
                                                    onChange={(e) => handleProgramChange(e, program.id, program.name)}
                                                    style={{color:"#fff !important"}}
                                                />
                                            ))}

                                            <Form.Check
                                                type="checkbox"
                                                label="Other/Custom"
                                                name="programs"
                                                value="Other/Custom"
                                                checked={formData.programs.includes("Other/Custom")}
                                                onChange={(e) => handleProgramChange(e, "Other/Custom")}
                                            />

                                            {formData.programs.includes("Other/Custom") && (
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter custom program"
                                                    value={customProgram}
                                                    onChange={(e) => {
                                                        setCustomProgram(e.target.value)
                                                    }}
                                                    className="mt-2"
                                                />
                                            )}
                                    </Form.Group>

                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Residence Type*</Form.Label>
                                            {residentsTypes && residentsTypes.map((residentsType) => (
                                                <Form.Check
                                                    key={residentsType.id}
                                                    type="checkbox"
                                                    label={residentsType.name}
                                                    name="residenceType"
                                                    value={residentsType.id}
                                                    checked={formData.residenceType.includes(residentsType.name)}
                                                    onChange={(e) => handleResidenceTypeChange(e, residentsType.id, residentsType.name)}
                                                />
                                            ))}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Program Duration*</Form.Label>
                                            {['2 Days', '2-5 Days', '7 Days', '15 Days', '21 Days', '28 Days', 'Other'].map((duration) => (
                                                <Form.Check
                                                    key={duration}
                                                    type="checkbox"
                                                    label={duration}
                                                    name="programDuration"
                                                    value={duration}
                                                    checked={
                                                        duration === "2-5 Days" || duration === "Other"
                                                            ? formData.duration.includes(duration)
                                                            : formData.duration.includes(parseInt(duration, 10))
                                                    }
                                                onChange={(e) => handleProgramDurationChange(e, duration)}
                                            />
                                            ))}
                                        </Form.Group>

                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>How did you hear about us?*</Form.Label>
                                            {[
                                                "Google Search",
                                                "Airbnb",
                                                "Instagram Post",
                                                "Magazine/Article",
                                                "Influencer Reel",
                                                "Travel Agent/Online Agency",
                                                "Strategic Partner",
                                                "Referral",
                                                "Other"
                                            ].map((option, index) => (
                                                <div key={index}>
                                                    <Form.Check
                                                        key={index}
                                                        type="checkbox"
                                                        label={option}
                                                        value={option}
                                                        checked={formData.source.includes(option)}
                                                        onChange={(e) => handleSourceChange(e)}
                                                    />

                                                    {option === "Magazine/Article" && formData.source.includes("Magazine/Article") && (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Magazine/Article name"
                                                            value={magazineValue}
                                                            onChange={(e) => {
                                                                setMagazineValue(e.target.value);
                                                            }}
                                                            className="mt-2"
                                                        />
                                                    )}

                                                    {option === "Influencer Reel" && formData.source.includes("Influencer Reel") && (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Influencer Reeler name"
                                                            value={influencerReelValue}
                                                            onChange={(e) => {
                                                                setInfluencerReelValue(e.target.value);
                                                            }}
                                                            className="mt-2"
                                                        />
                                                    )}

                                                    {option === "Travel Agent/Online Agency" && formData.source.includes("Travel Agent/Online Agency") && (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Travel Agent/Online Agency name"
                                                            value={travelAgencyValue}
                                                            onChange={(e) => {
                                                                setTravelAgencyValue(e.target.value);
                                                            }}
                                                            className="mt-2"
                                                        />
                                                    )}
                                                    {option === "Strategic Partner" && formData.source.includes("Strategic Partner") && (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Strategic Partner name"
                                                            value={strategicPartnerValue}
                                                            onChange={(e) => {
                                                                setStrategicPartnerValue(e.target.value);
                                                            }}
                                                            className="mt-2"
                                                        />
                                                    )}
                                                    {option === "Referral" && formData.source.includes("Referral") && (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter referral name"
                                                            value={referralName}
                                                            onChange={(e) => {
                                                                setReferralName(e.target.value);
                                                            }}
                                                            className="mt-2"
                                                        />
                                                    )}

                                                    {option === "Other" && formData.source.includes("Other") && (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Please explain"
                                                            value={otherValue}
                                                            onChange={(e) => {
                                                                setOtherValue(e.target.value);
                                                            }}
                                                            className="mt-2"
                                                        />
                                                    )}

                                                </div>
                                        ))}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-4">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Expected Check-In Date</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="date"
                                                    name="checkinDate"
                                                    placeholder="Enter Expected Check-In Date"
                                                    value={formData.checkinDate}
                                                    onChange={handleChange}
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Expected Check-Out Date</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="date"
                                                    name="checkoutDate"
                                                    placeholder="Enter Expected Check-Out Date"
                                                    value={formData.checkoutDate}
                                                    onChange={handleChange}
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            <Row className="mb-4">
                            <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Travel Medium</Form.Label>
                                            {[
                                                "Manohar International Airport (MOPA, North Goa - GOX)",
                                                "Sindhudurg Airport (Chipi SDW)",
                                                "Self-driving",
                                                "Kudal Station (Train)",
                                                "Other"
                                            ].map((option, index) => (
                                                <div key={index}>
                                                    <Form.Check
                                                        key={index}
                                                        type="checkbox"
                                                        label={option}
                                                        value={option}
                                                        checked={formData.travelMedium.includes(option)}
                                                        onChange={(e) => handleTravelMediumChange(e)}
                                                    />

                                                    {option === "Other" && formData.travelMedium.includes("Other") && (
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Please Enter Your Travel Medium"
                                                            value={travelMediumOtherValue}
                                                            onChange={(e) => {
                                                                setTravelMediumOtherValue(e.target.value);
                                                            }}
                                                            className="mt-2"
                                                        />
                                                    )}

                                                </div>
                                            ))}
                                        </Form.Group>
                                    </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Subscribe/Newsletter</Form.Label>
                                        {['SMS', 'Whatsapp', 'Email'].map((option) => (
                                            <Form.Check
                                                key={option}
                                                type="checkbox"
                                                label={option}
                                                value={option}
                                                checked={formData.subscription.includes(option)}
                                                onChange={(e) => handleSubscriptionChange(e)}
                                            />
                                        ))}
                                    </Form.Group>
                                </Col>

                            </Row>
                            <Button type="submit" className="sbmtbtn">
                                {"Submit"}
                            </Button>

                            {isEditMode ?
                                <Button variant="secondary" className="ms-3" onClick={handleNewEntry}>
                                    Create New Entry
                                </Button>
                                : ''
                            }
                        </Form>
                    </Col>
                </Row>
                <div class="belantara-map px-md-5 px-4 py-5">
                {/* <iframe src="https://earth.google.com/earth/d/1V-C3cm-fPm6ku991OmhkmyFcJxP2FQlf?usp=sharing" width="640" height="480"></iframe> */}
                
                <iframe src="https://www.google.com/maps/embed?pb=!1m34!1m12!1m3!1d255554.08625968886!2d73.53321184589198!3d15.850871160806241!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m19!3e0!4m5!1s0x3bbf8d4ebff4c7bb%3A0x1b82a0d04cf6def6!2sManohar%20International%20Airport%2C%20GOA%20(GOX)%2C%20Taluka%20Pernem%2C%20Mopa%2C%20Goa!3m2!1d15.7377224!2d73.8694478!4m5!1s0x3bc003c26143b5c1%3A0xe2caa83ef014b1a7!2sChipi%20Airport%20Road%2C%20Maharashtra!3m2!1d15.995011799999999!2d73.5324957!4m5!1s0x3bc000cd4be20655%3A0x7b105b213d5c5a07!2sBelantara%20Beachfront%2C%20Pagerewadi%20Khavne%2C%20Maharashtra%20416522!3m2!1d15.9247161!2d73.5575922!5e1!3m2!1sen!2sin!4v1736234279103!5m2!1sen!2sin"
                  width="100%"
                  height="450" 
                  allowfullscreen="" 
                  loading="lazy" 
                  referrerpolicy="no-referrer-when-downgrade">
                  </iframe>
            </Container >
            <Footer />
        </>
    );
};

export default ContactForm;